<app-chips-ungrouped
  [truncate]="truncate"
  [reportType]="reportType"
  [data]="chips"
  (chipRemoved)="chipRemovedHandler($event)"
></app-chips-ungrouped>
